import { IdsMainButton, IdsModal } from "@ids/react"

import { formatters } from "@garantidos/utils"

import "./style.scss"

import { simulationOfferDetailsAmortizationSystemTextsMap } from "./data"

export function SimulationOfferDetails({
  show,
  onCloseClick,
  offer,
  onSubmitOffer
}) {
  const amortizationSystemTexts =
    simulationOfferDetailsAmortizationSystemTextsMap[offer.amortization_system]

  return (
    <IdsModal
      open={show}
      setOpen={onCloseClick}
      title="Detalhes da simulação"
      width="500px"
      noDivider
      footer={
        <IdsMainButton id="choose-conditions-button" onClick={onSubmitOffer}>
          Seguir com essas condições
        </IdsMainButton>
      }
      className="simulation-offer-details__modal"
    >
      <div className="simulation-offer-details">
        <div>
          <h2 className="simulation-offer-details__subtitle">
            {amortizationSystemTexts.subtitle}
          </h2>
          <p className="simulation-offer-details__description">
            {amortizationSystemTexts.description}
          </p>
        </div>

        <div>
          <h2 className="simulation-offer-details__subtitle">
            Valores totais e custos
          </h2>

          <div>
            <div className="simulation-offer-details__rates-wrapper">
              <p className="simulation-offer-details__rate-title">
                Somatória das parcelas
              </p>
              <p className="simulation-offer-details__rate-value">
                {formatters.toCurrency(offer.total_installments_value)}
              </p>
            </div>
            <div className="simulation-offer-details__rates-wrapper">
              <p className="simulation-offer-details__rate-title">
                Custo efetivo total
              </p>
              <p className="simulation-offer-details__rate-value">{`${formatters.floatToDisplayableNumber(
                offer.yearly_effective_interest_rate
              )}% a.a.`}</p>
            </div>
            <div className="simulation-offer-details__rates-wrapper">
              <p className="simulation-offer-details__rate-title">
                Taxa de juros
              </p>
              <p className="simulation-offer-details__rate-value">{`${formatters.floatToDisplayableNumber(
                offer.yearly_effective_rate
              )}% a.a.`}</p>
            </div>
            <div className="simulation-offer-details__rates-wrapper">
              <p className="simulation-offer-details__rate-title">IOF</p>
              <p className="simulation-offer-details__rate-value">
                {formatters.toCurrency(offer.iof_total_value)}
              </p>
            </div>

            <div className="simulation-offer-details__rates-wrapper">
              <p className="simulation-offer-details__rate-title">
                Prazo das parcelas
              </p>
              <p className="simulation-offer-details__rate-value">
                {`${formatters.monthsToYears(offer.financing_term)} anos`}
              </p>
            </div>
          </div>
        </div>
      </div>
    </IdsModal>
  )
}
